import { useCrmLevelSyncStore } from '~/stores/crm-level-sync';

// Gatilho da regularização de nível CRM (stores/crm-level-sync.ts).
//
// Vive num plugin pelo mesmo motivo do player-profile.client.ts: a detecção não
// pertence a tela nenhuma — os dois lados da comparação chegam por caminhos
// assíncronos independentes (o /players/me pelo plugin de sessão, o nível da
// Smartico quando o SDK termina o identify), em qualquer ordem, com o jogador
// em qualquer rota.
//
// O watcher pode disparar quantas vezes for: quem garante "no máximo uma
// chamada por divergência detectada" é a store (assinatura por par de slugs),
// não a frequência daqui. Por isso não há debounce no watch — o freio de
// verdade é idempotência, que segura inclusive render/polling.
export default defineNuxtPlugin(() => {
  const syncStore = useCrmLevelSyncStore();
  const { isDiverged } = storeToRefs(syncStore);

  const { userId } = useUserData();

  watch(
    isDiverged,
    (diverged) => {
      if (diverged) syncStore.syncIfDiverged();
    },
    { immediate: true },
  );

  // Troca de conta / logout: o histórico de tentativa era do jogador anterior.
  watch(userId, (id, previousId) => {
    if (previousId && previousId !== id) syncStore.reset();
  });
});
